import type { ReorderPresentation } from "@/domain/reorder/reorder.types";

const REORDER_NOTICE_KEY = "rx-reorder-notice-v1";

export type ReorderCartNotice = {
  headline: string;
  primaryAction: ReorderPresentation["primaryAction"];
  createdAt: number;
};

function canUseSessionStorage(): boolean {
  try {
    return typeof sessionStorage !== "undefined";
  } catch {
    return false;
  }
}

export function setReorderCartNotice(presentation: ReorderPresentation): void {
  if (!canUseSessionStorage()) return;
  if (
    presentation.primaryAction !== "review_items" &&
    presentation.primaryAction !== "browse_menu"
  ) {
    return;
  }

  const notice: ReorderCartNotice = {
    headline: presentation.headline,
    primaryAction: presentation.primaryAction,
    createdAt: Date.now(),
  };

  try {
    sessionStorage.setItem(REORDER_NOTICE_KEY, JSON.stringify(notice));
  } catch {
    // ignore quota / private mode
  }
}

export function peekReorderCartNotice(): ReorderCartNotice | null {
  if (!canUseSessionStorage()) return null;
  try {
    const raw = sessionStorage.getItem(REORDER_NOTICE_KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw) as ReorderCartNotice;
    if (!parsed?.headline || typeof parsed.headline !== "string") return null;
    return parsed;
  } catch {
    return null;
  }
}

export function clearReorderCartNotice(): void {
  if (!canUseSessionStorage()) return;
  try {
    sessionStorage.removeItem(REORDER_NOTICE_KEY);
  } catch {
    // ignore
  }
}
